/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { MPlugins, mj } from 'js/entry/util.js';
import { $, convertToSelect2WithDefaultFit } from 'js/entry/base.js';
import { mjt } from 'js/entry/i18ntexts.js';

import { showInfoToast, confirm_box, big_confirm_box } from 'js/entry/page.js';

import { Lightbox, MVSearch, MVResult, RVFilteredObjectItemsSource } from 'js/entry/media.js';

import { queryCachedInquirerVoting, clearInquirerVotingCache, finishInquirerVotingApproverVotes, submitInquirerVotingFinalVotes } from './inquirer_voting.js';

import { queryCachedApproverVotes, getAllApproverVotesGroups, submitApproverVotes } from './approver_votes.js';


function updateFilterOptionCount( $option, count ) {
	var text = $option.text();
	var x = text.lastIndexOf('(');
	if( x!==-1 ) text = text.substr(0,x);
	text = text.trim();
	text += ' ('+count+')';
	$option.text(text);
}


/**
 *
 */
MPlugins.register( [$,mj], 'ui-votings-result-info-view-hooks', function($,mj) {

	function updateInquirerViewInfo( xinfo_elem, inquirer_voting ) {
		// // eslint-disable-next-line
		// console.log({ plugin:'MediaResultInfoView', fn:'updateInquirerViewInfo', list_count, inquirer_voting });
		// var items_count = list_count || 0;
		$('#votings-feedback-state',xinfo_elem)
			.html(inquirer_voting.getShortFeedbackHTML())
			.attr('title','voting_id='+inquirer_voting.getVotingId())
			.data('mj-custom-tooltip', () => '<div class="votings-feedback-tooltip">'+inquirer_voting.getFullFeedbackHTML()+'</div>' );
	}

	function updateApproverVotesCounts( xinfo_elem, list_count, approver_votes ) {
		//console.log({ fn:'ui-votings-result-info-view-hooks::updateApproverVotesCounts', list_count, approver_votes });
		var counts = getAllApproverVotesGroups(list_count,approver_votes);
		var counts_text = mjt('votings-info-counts')
			.replace(/%1/,counts.approved)
			.replace(/%2/,counts.rejected)
			.replace(/%3/,counts.unrated);
		$('#votings-approvers-selection-state',xinfo_elem)
			.attr('title',counts_text)
			.text(counts_text);
	}



	function initApproversViewVotingStateFilter( list_data_obj ) {
		if( !list_data_obj._state.hasOwnProperty('filter') ) {
			list_data_obj._state.filter = {
				// approvers view
				voting_state: '',
			};
		}
	}

	function createApproversViewVotingStateFilterFunctions( approver_votes, all_media_ids ) {
		// approvers view
		return {
			voting_state: function( media_ids, flt_value ) {
				// flt_value = approved | rejected | unrated
				if( flt_value==='unrated' ) {
					return all_media_ids.filter( media_id => {
						if( !approver_votes.hasOwnProperty(media_id) ) return true;
						var vote_value = approver_votes[media_id];
						return !( vote_value===true || vote_value===false );
					} );
				}
				return media_ids.filter( media_id => {
					if( !approver_votes.hasOwnProperty(media_id) ) return false;
					var vote_value = approver_votes[media_id];
					if( flt_value==='approved' ) return vote_value===true;
					else if( flt_value==='rejected' ) return vote_value===false;
				} );
			},
		};
	}


	function appendApproversViewVotingStateFilter( changed_dt, submitted_dt, approver_votes, media_ids, xinfo_elem, info_elem, list_data_obj, search_info_obj ) {
		$('#votings-filter-by-approvers-voting-state').select2('destroy').remove();
		$('label[for=votings-filter-by-approvers-voting-state]').remove();

		let $select_elem = $('<select id="votings-filter-by-approvers-voting-state" size="1" class="small">'
			+'<option value="">'+mjt('votings-filter-by-approvers-voting-state-all')+'</option>'
			+'<option value="approved" class="x-approved">'+mjt('votings-filter-by-approvers-voting-state-approved')+'</option>'
			+'<option value="rejected" class="x-rejected">'+mjt('votings-filter-by-approvers-voting-state-rejected')+'</option>'
			+'<option value="unrated" class="x-unrated">'+mjt('votings-filter-by-approvers-voting-state-unrated')+'</option>'
			+'</select>').prependTo(xinfo_elem);
		xinfo_elem.prepend('<label for="votings-filter-by-approvers-voting-state">'+mjt('votings-filter-by-approvers-voting-state')+'</label>');
		updateApproversViewVotingStateFilter($select_elem,true,changed_dt,submitted_dt,approver_votes,media_ids);
		convertToSelect2WithDefaultFit($select_elem,false);
		initApproversViewVotingStateFilter(list_data_obj);
		$select_elem.on( 'change', function(e) {
			var filter_val = $(this).val();
			var cur_filter = list_data_obj._state.filter.voting_state || '';
			if( filter_val==cur_filter ) return;
			list_data_obj._state.filter.voting_state = filter_val;

			var s2cont = $(this).next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-unrated').addClass('x-'+filter_val);

			var object_item = list_data_obj._state.object_item || {};
			var cur_approver_votes = $(this).data('x-approver-votes');
			var source_obj = new RVFilteredObjectItemsSource( list_data_obj._state.list_type, list_data_obj._state.list_id, object_item, list_data_obj._state.filter, createApproversViewVotingStateFilterFunctions(cur_approver_votes,media_ids) );
			MVResult.getWidget().loadSource( source_obj, object_item, false, function _load_done() {
			} );
		} );
		// .. result init .. .. $select_elem ..
		$select_elem.val(list_data_obj._state.filter.voting_state);
		$select_elem.trigger('change');
		updateApproversViewVotingStateFilter($select_elem,false,changed_dt,submitted_dt,approver_votes,media_ids);
	}

	function updateApproversViewVotingStateFilter( $select_elem, initial, changed_dt, submitted_dt, approver_votes, media_ids ) {
		var approver_votes_groups = getAllApproverVotesGroups(media_ids.length,approver_votes);
		var $options = $select_elem.find('option');
		updateFilterOptionCount( $options.first(), approver_votes_groups.all||0 );
		updateFilterOptionCount( $options.filter('[value=approved]'), approver_votes_groups.approved||0 );
		updateFilterOptionCount( $options.filter('[value=rejected]'), approver_votes_groups.rejected||0 );
		updateFilterOptionCount( $options.filter('[value=unrated]'), approver_votes_groups.unrated||0 );
		$select_elem.data('x-approver-votes',approver_votes);
		if( !initial ) {
			var filter_val = $select_elem.val();
			// $select_elem.select2('destroy');
			// convertToSelect2WithDefaultFit($select_elem,false);
			var s2cont = $select_elem.next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-unrated').addClass('x-'+filter_val);
		}
	}




	function initInquirersViewVotingStateFilter( list_data_obj ) {
		if( !list_data_obj._state.hasOwnProperty('filter') ) {
			list_data_obj._state.filter = {
				// inquirers view
				all_approvers_voting_state: '',
				final_voting_state: '',
			};
		}
	}

	function createInquirersViewVotingStateFilterFunctions( inquirer_voting ) {
		// inquirers view
		return {
			all_approvers_voting_state: function( media_ids, flt_value ) {
				// flt_value = approved | rejected | ambiguous | unrated
				return media_ids.filter( media_id => {
					var counts = inquirer_voting.getApprovalVotesForMediaId(media_id);
					return counts.combined_status===flt_value;
				} );
			},
			final_voting_state: function( media_ids, flt_value ) {
				// flt_value = open | approved | rejected
				return media_ids.filter( media_id => {
					var final_vote = inquirer_voting.getFinalVotesCombinedStateForMediaId(media_id);
					if( flt_value==='approved' ) return final_vote===true;
					else if( flt_value==='rejected' ) return final_vote===false;
					else if( flt_value==='open' ) return final_vote==null;
				} );
			},
		};
	}

	function appendInquirersViewVotingStateFilter( inquirer_voting, xinfo_elem, info_elem, list_data_obj, search_info_obj ) {
		$('#votings-filter-by-all-approvers-voting-state').select2('destroy').remove();
		$('label[for=votings-filter-by-all-approvers-voting-state]').remove();

		let $select_elem = $('<select id="votings-filter-by-all-approvers-voting-state" size="1" class="small">'
			+'<option value="">'+mjt('votings-filter-by-all-approvers-voting-state-all')+'</option>'
			+'<option value="approved" class="x-approved">'+mjt('votings-filter-by-all-approvers-voting-state-approved')+'</option>'
			+'<option value="rejected" class="x-rejected">'+mjt('votings-filter-by-all-approvers-voting-state-rejected')+'</option>'
			+'<option value="ambiguous" class="x-ambiguous">'+mjt('votings-filter-by-all-approvers-voting-state-ambiguous')+'</option>'
			+'<option value="unrated" class="x-unrated">'+mjt('votings-filter-by-all-approvers-voting-state-unrated')+'</option>'
			+'</select>').prependTo(xinfo_elem);
		xinfo_elem.prepend('<label for="votings-filter-by-all-approvers-voting-state">'+mjt('votings-filter-by-all-approvers-voting-state')+'</label>');
		updateInquirersViewVotingStateFilter($select_elem,true,inquirer_voting);
		convertToSelect2WithDefaultFit($select_elem,false);
		initInquirersViewVotingStateFilter(list_data_obj);
		$select_elem.on( 'change', function(e) {
			var filter_val = $(this).val();
			var cur_filter = list_data_obj._state.filter.all_approvers_voting_state || '';
			if( filter_val==cur_filter ) return;
			list_data_obj._state.filter.all_approvers_voting_state = filter_val;

			var s2cont = $(this).next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-ambiguous x-unrated').addClass('x-'+filter_val);

			var object_item = list_data_obj._state.object_item || {};
			var cur_inquirer_voting = $(this).data('x-inquirer-voting');
			var source_obj = new RVFilteredObjectItemsSource( list_data_obj._state.list_type, list_data_obj._state.list_id, object_item, list_data_obj._state.filter, createInquirersViewVotingStateFilterFunctions(cur_inquirer_voting) );
			MVResult.getWidget().loadSource( source_obj, object_item, false, function _load_done() {
			} );
		} );
		// .. result init .. .. $select_elem ..
		$select_elem.val(list_data_obj._state.filter.all_approvers_voting_state);
		$select_elem.trigger('change');
		updateInquirersViewVotingStateFilter($select_elem,false,inquirer_voting);
	}

	function updateInquirersViewVotingStateFilter( $select_elem, initial, inquirer_voting ) {
		var combined_approval_votes_groups = inquirer_voting.getAllCombinedApprovalVotesGroups();
		var $options = $select_elem.find('option');
		updateFilterOptionCount( $options.first(), combined_approval_votes_groups.all||0 );
		updateFilterOptionCount( $options.filter('[value=approved]'), combined_approval_votes_groups.approved||0 );
		updateFilterOptionCount( $options.filter('[value=rejected]'), combined_approval_votes_groups.rejected||0 );
		updateFilterOptionCount( $options.filter('[value=ambiguous]'), combined_approval_votes_groups.ambiguous||0 );
		updateFilterOptionCount( $options.filter('[value=unrated]'), combined_approval_votes_groups.unrated||0 );
		$select_elem.data('x-inquirer-voting',inquirer_voting);
		if( !initial ) {
			var filter_val = $select_elem.val();
			// $select_elem.select2('destroy');
			// convertToSelect2WithDefaultFit($select_elem,false);
			var s2cont = $select_elem.next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-ambiguous x-unrated').addClass('x-'+filter_val);
		}
	}


	function appendInquirersViewFinalVotingStateFilter( inquirer_voting, xinfo_elem, info_elem, list_data_obj, search_info_obj ) {
		$('#votings-filter-by-final-voting-state').select2('destroy').remove();
		$('label[for=votings-filter-by-final-voting-state]').remove();

		xinfo_elem.append('<label for="votings-filter-by-final-voting-state">'+mjt('votings-filter-by-final-voting-state')+'</label>');
		let $select_elem = $('<select id="votings-filter-by-final-voting-state" size="1" class="small">'
			+'<option value="">'+mjt('votings-filter-by-final-voting-state-all')+'</option>'
			+'<option value="open" class="x-open">'+mjt('votings-filter-by-final-voting-state-open')+'</option>'
			+'<option value="approved" class="x-approved">'+mjt('votings-filter-by-final-voting-state-approved')+'</option>'
			+'<option value="rejected" class="x-rejected">'+mjt('votings-filter-by-final-voting-state-rejected')+'</option>'
			+'</select>').appendTo(xinfo_elem);
		updateInquirersViewFinalVotingStateFilter($select_elem,true,inquirer_voting);
		convertToSelect2WithDefaultFit($select_elem,false);
		initInquirersViewVotingStateFilter(list_data_obj);
		$select_elem.on( 'change', function(e) {
			var filter_val = $(this).val();
			var cur_filter = list_data_obj._state.filter.final_voting_state || '';
			if( filter_val==cur_filter ) return;
			list_data_obj._state.filter.final_voting_state = filter_val;

			var s2cont = $(this).next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-open').addClass('x-'+filter_val);

			var object_item = list_data_obj._state.object_item || {};
			var cur_inquirer_voting = $(this).data('x-inquirer-voting');
			var source_obj = new RVFilteredObjectItemsSource( list_data_obj._state.list_type, list_data_obj._state.list_id, object_item, list_data_obj._state.filter, createInquirersViewVotingStateFilterFunctions(cur_inquirer_voting) );
			MVResult.getWidget().loadSource( source_obj, object_item, false, function _load_done() {
			} );
		} );
		// .. result init .. .. $select_elem ..
		$select_elem.val(list_data_obj._state.filter.final_voting_state);
		$select_elem.trigger('change');
		updateInquirersViewFinalVotingStateFilter($select_elem,false,inquirer_voting);
	}

	function updateInquirersViewFinalVotingStateFilter( $select_elem, initial, inquirer_voting ) {
		var combined_final_votes_groups = inquirer_voting.getAllCombinedFinalVotesGroups();
		var $options = $select_elem.find('option');
		updateFilterOptionCount( $options.first(), combined_final_votes_groups.all||0 );
		updateFilterOptionCount( $options.filter('[value=open]'), combined_final_votes_groups.open||0 );
		updateFilterOptionCount( $options.filter('[value=approved]'), combined_final_votes_groups.approved||0 );
		updateFilterOptionCount( $options.filter('[value=rejected]'), combined_final_votes_groups.rejected||0 );
		$select_elem.data('x-inquirer-voting',inquirer_voting);
		if( !initial ) {
			var filter_val = $select_elem.val();
			// $select_elem.select2('destroy');
			// convertToSelect2WithDefaultFit($select_elem,false);
			var s2cont = $select_elem.next('.select2-container').toggleClass('active',filter_val!='');
			if( filter_val!='' ) s2cont.removeClass('x-approved x-rejected x-open').addClass('x-'+filter_val);
		}
	}


	return {
		type: 'MediaResultInfoView',

		afterApplyInquirerApprovalVotesToResultView: function( voting_id, object_item, inquirer_voting ) {
			// TODO ?
		},

		afterApplyInquirerFinalVotesToResultView: function( voting_id, object_item, inquirer_voting ) {
			var mri = $('#media-result-info');
			var xinfo_elem = mri.find('.xinfo');
			var xactions_elem = mri.find('.xactions');

			// // eslint-disable-next-line
			// console.log({ fn:'MediaResultInfoView::afterApplyInquirerFinalVotesToResultView', voting_id, object_item, inquirer_voting });

			// enable/disable submit actions ..
			var $finish_btn = $('#votings-finish-voting-approver-votes',xactions_elem);
			if( $finish_btn.length ) $finish_btn.prop('disabled',inquirer_voting.voting.final_votes_started_dt!=null);

			var $final_finish_btn = $('#votings-finish-voting-final-votes',xactions_elem);
			if( $final_finish_btn.length ) $final_finish_btn.prop('disabled',inquirer_voting.voting.final_votes_started_dt!=null&&inquirer_voting.voting.final_votes_submitted_dt!=null);

			updateInquirersViewVotingStateFilter( $('#votings-filter-by-all-approvers-voting-state'), false, inquirer_voting );
			updateInquirersViewFinalVotingStateFilter( $('#votings-filter-by-final-voting-state'), false, inquirer_voting );
			updateInquirerViewInfo( xinfo_elem, inquirer_voting );
		},

		afterApplyApproversVotesToResultView: function( voting_id, object_item, approver_votes_changed_dt, approver_votes_submitted_dt, approver_votes, media_ids ) {
			var mri = $('#media-result-info');
			var xinfo_elem = mri.find('.xinfo');
			var xactions_elem = mri.find('.xactions');

			// // eslint-disable-next-line
			// console.log({ fn:'MediaResultInfoView::afterApplyApproversVotesToResultView', voting_id, object_item, approver_votes_submitted_dt, approver_votes, media_ids });

			// enable/disable submit action ..
			var $submit_btn = $('#votings-submit-approvers-voting-state',xactions_elem);
			if( $submit_btn.length ) $submit_btn.prop('disabled',approver_votes_submitted_dt!=null);

			updateApproversViewVotingStateFilter( $('#votings-filter-by-approvers-voting-state'), false, approver_votes_changed_dt, approver_votes_submitted_dt, approver_votes, media_ids );
			updateApproverVotesCounts( xinfo_elem, object_item.count||0, approver_votes );
		},

		afterUpdateResultInfo: function( info_elem, list_data_obj, search_info_obj ) {

			// // eslint-disable-next-line
			// console.log({ fn:'MediaResultInfoView::afterUpdateResultInfo', info_elem, list_data_obj, search_info_obj });

			var list_type = list_data_obj ? (list_data_obj._state.list_type || 'unknown') : 'unknown';
			if( list_type!=='lightbox' ) return;

			var object_item = list_data_obj._state.object_item || {};
			var x_plugin = object_item.x_plugin || null;
			if( x_plugin==null ) return;
			var voting_id = object_item.x_id || 0;
			var user_is_owner_of_lb = mj.user_id==object_item.owner_id;


			var xinfo_elem = info_elem.find('> .xinfo').detach();
			if( xinfo_elem.length===0 ) xinfo_elem = $('<span class="xinfo"></span>');
			var xactions_elem = info_elem.find('> .xactions').detach();
			if( xactions_elem.length===0 ) xactions_elem = $('<span class="xactions"></span>');

			// var xinfo_elem = $('<span class="xinfo"></span>');
			// var xactions_elem = $('<span class="xactions"></span>');
			if( user_is_owner_of_lb ) {
				// inquirers view: ...
				var update_view_from_inquirer_voting;

				xinfo_elem.append(	'<label for="votings-feedback-state">'+mjt('votings-feedback-state')+'</label>'
								+   '<span id="votings-feedback-state" class="xinfo-item right"></span>' );

				var show_approvers_voting_state_filter = (inquirer_voting) => {
					appendInquirersViewVotingStateFilter( inquirer_voting, xinfo_elem, info_elem, list_data_obj, search_info_obj );
				};

				var show_final_voting_state_filter = (inquirer_voting) => {
					appendInquirersViewFinalVotingStateFilter( inquirer_voting, xinfo_elem, info_elem, list_data_obj, search_info_obj );
				};

				var show_reload_btn = (inquirer_voting) => {
					var $reload_btn = $('<a id="votings-refresh-voting-approver-votes" href="#" class="icon fa fa-refresh link" style="margin-right:12px; padding:4px 6px" title="'+mjt('votings-refresh-voting-approver-votes')+'"></a>').appendTo(xactions_elem);
					$reload_btn.on( 'click', function(e) {
						e.preventDefault();
						$reload_btn.addClass('disabled');
						clearInquirerVotingCache(voting_id);
						queryCachedInquirerVoting( voting_id, function( new_inquirer_voting ) {
							$reload_btn.removeClass('disabled');
							if( inquirer_voting.voting.changed_dt===new_inquirer_voting.voting.changed_dt ) {
								showInfoToast( mjt('votings-refresh-voting-approver-votes-done-no-change') );
							} else {
								showInfoToast( mjt('votings-refresh-voting-approver-votes-done-updated') );
								// update view ...
								update_view_from_inquirer_voting(new_inquirer_voting);
								updateInquirersViewVotingStateFilter( $('#votings-filter-by-all-approvers-voting-state'), false, new_inquirer_voting );
								// var object_item = list_data_obj._state.object_item || {};
								// var source_obj = new RVFilteredObjectItemsSource(list_data_obj._state.list_type,list_data_obj._state.list_id,object_item,list_data_obj._state.filter,createInquirersViewVotingStateFilterFunctions(inquirer_voting));
								// MVResult.getWidget().loadSource( source_obj, object_item, false, function _load_done() {
								// } );

								// fully update view only when actual changes occured meanwhile
								if( new_inquirer_voting.voting.changed_dt!=inquirer_voting.voting.changed_dt ) {

									// load lightbox list, load next lightbox, update lightbox view states
									const object_id_enc = new_inquirer_voting.voting.lightbox_object_id;
									Lightbox.triggerGo(object_id_enc,'force');
								}
							}
						} );
					} );
				};

				var show_finish_btn = (inquirer_voting) => {
					var $finish_btn = $('<button id="votings-finish-voting-approver-votes" class="small"><span class="label">'+mjt('votings-action-finish-voting-approver-votes')+'</span></button>').appendTo(xactions_elem);
					$finish_btn.on( 'click', function(e) {
						big_confirm_box(
							mjt('votings-action-finish-voting-approver-votes-confirm-title'),
							mjt('votings-action-finish-voting-approver-votes-confirm-message'),
							() => {
								$finish_btn.prop('disabled',true);
								finishInquirerVotingApproverVotes( voting_id, ( new_inquirer_voting ) => {
									// // eslint-disable-next-line
									// console.log({ msg:'inquirers voting "approver votes" finished!', new_inquirer_voting });
									showInfoToast( mjt('votings-action-finish-voting-approver-votes-done') );

									// update view ...
									updateInquirerViewInfo( xinfo_elem, new_inquirer_voting );

									// // load lightbox list, load next lightbox, update lightbox view states
									const object_id_enc = new_inquirer_voting.voting.lightbox_object_id;
									Lightbox.triggerGo(object_id_enc,'force');
								} );
							}
						);
					} );
				};

				var show_final_finish_btn = (inquirer_voting) => {
					var $final_finish_btn = $('<button id="votings-finish-voting-final-votes" class="small"><span class="label">'+mjt('votings-action-final-finish-voting')+'</span></button>').appendTo(xactions_elem);
					$final_finish_btn.on( 'click', function(e) {
						big_confirm_box(
							mjt('votings-action-final-finish-confirm-title'),
							mjt('votings-action-final-finish-confirm-message')
							+'<br>\n'
							+'<br>\n'
							+'<i>'+mjt('votings-action-final-finish-confirm-message-2')+'</i>',
							() => {
								$final_finish_btn.prop('disabled',true);
								submitInquirerVotingFinalVotes( voting_id, ( new_inquirer_voting ) => {
									// // eslint-disable-next-line
									// console.log({ msg:'inquirers voting "final votes" finished!', new_inquirer_voting });
									showInfoToast( mjt('votings-action-final-finish-voting-done') );

									// update view ...
									updateInquirerViewInfo( xinfo_elem, new_inquirer_voting );

									// // load lightbox list, load next lightbox, update lightbox view states
									const object_id_enc = inquirer_voting.voting.lightbox_object_id;
									Lightbox.triggerGo(object_id_enc,'force');
								} );
							}
						);
					} );
				};

				update_view_from_inquirer_voting = (inquirer_voting) => {
					$('#votings-refresh-voting-approver-votes,#votings-finish-voting-final-votes,#votings-finish-voting-approver-votes').remove();
					if( !inquirer_voting.hasFinalVotesSubmitted() ) {
						show_approvers_voting_state_filter(inquirer_voting);
					}
					updateInquirerViewInfo(xinfo_elem,inquirer_voting);
					if( inquirer_voting.hasFinalVotesSubmitted() ) {
						show_final_voting_state_filter(inquirer_voting);
					} else if( inquirer_voting.hasFinalVotesStarted() ) {
						show_final_voting_state_filter(inquirer_voting);
						show_final_finish_btn(inquirer_voting);
					} else {
						if( !inquirer_voting.areAllApproverVotesSubmitted() ) {
							show_reload_btn(inquirer_voting);
						}
						show_finish_btn(inquirer_voting);
					}
				};

				queryCachedInquirerVoting( voting_id, update_view_from_inquirer_voting );


			} else {
				// approvers view: ...

				xinfo_elem.append(	'<label for="votings-approvers-selection-state">'+mjt('votings-approvers-selection-state')+'</label>'
								+	'<span id="votings-approvers-selection-state" class="xinfo-item right"></span>' );

				var show_voting_state_filter = (changed_dt,submitted_dt,approver_votes,media_ids) => {
					appendApproversViewVotingStateFilter( changed_dt, submitted_dt, approver_votes, media_ids, xinfo_elem, info_elem, list_data_obj, search_info_obj );
				};

				var show_submit_btn = () => {
					var $submit_btn = $('<button id="votings-submit-approvers-voting-state" class="small"><span class="label">'+mjt('votings-action-submit-voting')+'</span></button>').appendTo(xactions_elem);
					$submit_btn.on( 'click', function(e) {
						confirm_box(
							mjt('votings-action-submit-confirm-title'),
							mjt('votings-action-submit-confirm-message'),
							() => {
								$submit_btn.prop('disabled',true);
								submitApproverVotes( voting_id, (changed_dt,submitted_dt,approver_votes,media_ids,lightbox_object_id_enc) => {
									// // eslint-disable-next-line
									// console.log({ msg:'approvers votes submitted!', submitted_dt, votes });
									showInfoToast( mjt('votings-action-submit-voting-done') );

									// // NOTE: the lightbox just became inaccessible ..
									// // -> load search result into view ..
									Lightbox.invalidateCaches(lightbox_object_id_enc);
									MVSearch.loadCurrentSearchResultIntoResultView();

								} );
							}
						);
					} );
				};

				queryCachedApproverVotes( voting_id,
					(changed_dt,submitted_dt,approver_votes,media_ids) => {
						show_voting_state_filter(changed_dt,submitted_dt,approver_votes,media_ids);
						updateApproverVotesCounts(xinfo_elem,media_ids.length,approver_votes);
						show_submit_btn();
					}, function( jqXHR, textStatus, message ) {
						//TODO
						//console.log(textStatus);
					}
				);

			}

			info_elem.addClass('votings');
			info_elem.append([xinfo_elem,xactions_elem]);
		},
	};
} );
